var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0076 13.5708L45.9886 3L42.3165 7.08418L55.2521 17.655L59.0076 13.5708ZM19.1994 7.32443L15.5274 3.24025L2.5918 13.5708L6.26383 17.655L19.1994 7.32443ZM32.2184 19.8172H27.9622V36.0738L41.2316 43.8418L43.4849 40.6385L32.2184 34.1519V19.8172ZM30.7997 8.92606C16.6957 8.92606 5.42928 19.8172 5.42928 33.3511C5.42928 46.8849 16.6957 57.696 30.7997 57.696C44.9036 57.696 56.1701 46.8849 56.1701 33.3511C56.1701 19.8172 44.9036 8.92606 30.7997 8.92606ZM30.7997 52.2504C19.7836 52.2504 11.0208 43.8418 11.0208 33.271C11.0208 22.7002 19.7836 14.2916 30.7997 14.2916C41.8158 14.2916 50.5786 22.7002 50.5786 33.271C50.5786 43.8418 41.8158 52.2504 30.7997 52.2504Z",
    fill: "white",
    stroke: "#11B1CE",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector-1.5fd77fec813297786bb1d5ddcee8cd15.svg";
export { ForwardRef as ReactComponent };